<template>
  <div style="background: #fff">
    <headers />
    <div class="head">
      <img src="@/assets/images/communityBj.png" />
      <div class="headTit">社区联盟</div>
      <div class="searchBox">
        <search @search="searchFun" :type="2" />
      </div>
    </div>
    <div class="content" style="min-height: 400px">
      <transition name="community-loading-fade">
        <div v-if="loading" class="community-loading-overlay">
          <div class="community-loading-inner">
            <svg
              class="community-loading-svg"
              viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <circle
                class="community-loading-track"
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke-width="3"
              />
              <circle
                class="community-loading-arc"
                cx="24"
                cy="24"
                r="20"
                fill="none"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
            <p class="community-loading-text">加载中</p>
          </div>
        </div>
      </transition>
      <div class="headBox">
        <div class="headItem">联盟成员</div>
      </div>
      <div class="tabBox">
        <div
          @click="tabChange(-1)"
          :class="tabAct == -1 ? 'tabItemAct' : 'tabItem'"
        >
          全部
        </div>
        <div
          v-for="(item, index) in headTabList"
          :key="index"
          @click="tabChange(index)"
          :class="tabAct == index ? 'tabItemAct' : 'tabItem'"
        >
          {{ item.name }}
        </div>
        <!-- <div
            @click="tabChange(2)"
            :class="tabAct == 2 ? 'tabItemAct' : 'tabItem'"
          >
            L2专属课程
          </div>
          <div
            @click="tabChange(3)"
            :class="tabAct == 3 ? 'tabItemAct' : 'tabItem'"
          >
            L3专属课程
          </div> -->
      </div>
      <template v-if="list.length">
        <div
          class="card"
          v-for="(item, index) in list"
          :key="index"
          @click="toDetails(item)"
        >
          <div class="cardImg">
            <img v-if="item.image" class="hoverTransform" :src="item.image" />
            <div v-else class="cardImgTextBox MyCustomFont">
              <div>{{ item.abbr }}</div>
            </div>
          </div>
          <div class="cardR">
            <div class="cardRTit">{{ item.name }}</div>
            <div class="cardRIcon">
              <div
                class="cardRIconImte"
                v-if="item.equityClassifyNames.includes('L1')"
              >
                <img src="@/assets/images/L1.png" />
                <!-- L1级授权合作伙伴 -->
              </div>
              <div
                class="cardRIconImte"
                v-if="item.equityClassifyNames.includes('L2')"
              >
                <img src="@/assets/images/L2.png" />
                <!-- L2级授权合作伙伴 -->
              </div>
              <div
                class="cardRIconImte"
                v-if="item.equityClassifyNames.includes('L3')"
              >
                <img src="@/assets/images/L3.png" />
                <!-- L3级授权合作伙伴 -->
              </div>
              <div
                class="cardRIconImte"
                v-if="item.equityClassifyNames.includes('L4')"
              >
                <img src="@/assets/images/L4.png" />
                <!-- L4级授权合作伙伴 -->
              </div>
            </div>
            <div class="cardRAddress">
              <img src="@/assets/images/address.png" />
              所在地：{{ item.address }}
              <span v-if="item.address && item.businessAddress">,</span>
              <span>{{ item.businessAddress }}</span>
            </div>
            <!-- <div class="cardRBottom" v-if="item.rebateCompleteRate">
              <div class="cardRAddress" style="margin-top: 0">
                <img src="@/assets/images/fdIcon.png" />
                返点完成率：{{ item.rebateCompleteRate }}%
              </div>
            </div> -->
            <!-- <div class="cardRBottom">
              <div class="cardRAddress" style="margin-top: 0">
                <img src="@/assets/images/linkPeople.png" />
                联系人：{{ item.contacts }}
              </div>
              <div class="cardRAddress" style="margin-top: 0">
                <img src="@/assets/images/tel.png" />
                联系方式：{{ item.phone }}
              </div>
            </div> -->
          </div>
        </div>
      </template>
    </div>

    <div class="page" v-if="list.length">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pages.total"
        :current-page="pages.page"
        :page-size="pages.size"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>

    <None v-else-if="!loading" />
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";
import { videoEquityList } from "@/api/lx";
import { factoryList } from "@/api/lx";
export default {
  name: "Procucts",
  components: {
    headers,
    footers,
    search,
  },
  data() {
    return {
      searchValue: "",
      list: [],
      headTabList: [],
      tabAct: -1,
      pages: {
        page: 1,
        total: 0,
        size: 10,
      },
      loading: false,
      listRequestId: 0,
      minLoadingTime: 500,
    };
  },
  created() {
    // this.getList();
    this.getVideoEquityList();
  },
  mounted() {},
  methods: {
    getVideoEquityList() {
      videoEquityList({}).then((res) => {
        this.headTabList = res.data;
        this.getList();
      });
    },
    tabChange(val) {
      this.pages.page = 1;
      this.tabAct = val;
      this.getList();
    },
    currentChange(val) {
      this.pages.page = val;
      this.getList();
    },
    searchFun(val) {
      this.searchValue = val;
      this.pages.page = 1;
      this.getList();
    },
    getList() {
      const requestId = ++this.listRequestId;
      const startTime = Date.now();
      this.loading = true;
      factoryList({
        page: this.pages.page,
        size: this.pages.size,
        name: this.searchValue,
        equityClassifyId:
          this.tabAct == -1 ? "" : this.headTabList[this.tabAct].id,
      })
        .then((res) => {
          if (requestId !== this.listRequestId) return;
          this.list = res.data.records;
          this.pages.total = res.data.total;
        })
        .finally(() => {
          if (requestId !== this.listRequestId) return;
          const remain = this.minLoadingTime - (Date.now() - startTime);
          const delay = remain > 0 ? remain : 0;
          setTimeout(() => {
            if (requestId !== this.listRequestId) return;
            this.loading = false;
          }, delay);
        });
    },
    toSolutionDetails() {
      this.$router.push({
        path: "/forum/details",
        query: { id: 123 },
      });
    },
    /**
     * 跳转至盟友详情，若 canView 为 false 则提示当前权益不够并拦截
     * @param {Object} item - 盟友信息对象
     */
    toDetails(item) {
      if (item.canView === false) {
        this.$message.warning("当前权益/身份不够");
        return;
      }
      this.$router.push({
        name: "communityDetails",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 300px;
  position: relative;
  overflow: hidden;
  .headTit {
    width: 100%;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 42px;
    color: #ffffff;
    position: relative;
    z-index: 1;
    margin-top: 80px;
  }
  .searchBox {
    margin-top: 54px;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.community-loading-overlay {
  position: fixed;
  top: 74px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.community-loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}
.community-loading-svg {
  width: 44px;
  height: 44px;
  animation: community-loading-spin 0.9s linear infinite;
}
.community-loading-track {
  stroke: rgba(0, 216, 195, 0.18);
}
.community-loading-arc {
  stroke: #00d8c3;
  stroke-dasharray: 80 46;
  stroke-dashoffset: 0;
}
.community-loading-text {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #2b3339;
  letter-spacing: 0.5px;
}
.community-loading-fade-enter-active,
.community-loading-fade-leave-active {
  transition: opacity 0.28s ease;
}
.community-loading-fade-enter,
.community-loading-fade-leave-to {
  opacity: 0;
}
@keyframes community-loading-spin {
  100% {
    transform: rotate(360deg);
  }
}

.content {
  width: 100%;
  padding: 0 260px;
  box-sizing: border-box;
  margin-top: 30px;
  .headBox {
    width: 1400px;
    height: 48px;
    background: #f3f3f3;
    .headItem {
      width: 161px;
      height: 48px;
      background: #ffffff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #00161a;
      text-align: center;
      line-height: 48px;
      box-sizing: border-box;
      border-bottom: 3px solid #00d8c3;
    }
  }
  .card {
    cursor: pointer;
    width: 1400px;
    height: 200px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
    margin-top: 30px;
    padding: 0 30px;
    padding-bottom: 20px;
    box-sizing: border-box;
    .cardImg {
      width: 120px;
      height: 120px;
      overflow: hidden;
      .cardImgTextBox {
        width: 100%;
        height: 100%;
        font-size: 34px;
        background-color: #00d8c3;
        padding: 20px;
        box-sizing: border-box;
        color: #fff;
        word-break: break-all;
        display: flex;
        align-items: center;
        justify-content: center;
        div {
          text-align: center;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .cardR {
      margin-left: 20px;
      .cardRTit {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #00161a;
      }
      .cardRIcon {
        display: flex;
        margin-top: 9px;
        .cardRIconImte {
          display: flex;
          align-items: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #525f66;
          margin-right: 15px;
          img {
            width: 44px;
            height: 32px;
            margin-right: 15px;
          }
        }
      }
      .cardRAddress {
        display: flex;
        align-items: center;
        margin-top: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #525f66;
        img {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }
      }
      .cardRBottom {
        display: flex;
        margin-top: 10px;
        div {
          margin-right: 39px;
        }
      }
    }
  }
}

.page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 65px;
}

.tabBox {
  display: flex;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 45px;
  cursor: pointer;
  .tabItem {
    padding: 0 18px;
    height: 32px;
    line-height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #525f66;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e6edf0;
    margin-right: 20px;
  }
  .tabItemAct {
    padding: 0 18px;
    height: 32px;
    line-height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    background: #00d8c3;
    border-radius: 16px;
    border: 1px solid #00d8c3;
    margin-right: 20px;
  }
}
</style>
